module.exports = __webpack_public_path__ + "img/UI_RMYX_biaoqian_01_21572bf81.png";